import $ from 'jquery';
import tippy from 'tippy.js';
import tinycolor from 'tinycolor2';
import util, {convertMenuObjects, convertQrObjects, getSvgPath, addBlankAltText, syncUploadedImagesAltTextOnCanvas, syncUploadedIconsAltTextOnCanvas} from '../util';
import store from '../store';
import * as actions from '../actions';
import Matrix from './matrix';
import Text from './text';
import MenuObject from './menu-object';
import History from './history';
import Cached from './cached';
import Cleaner from './cleaner';
import designService from '../service/designService';
import constants from '../constants';
import {updateRuler, toggleRuler} from "./page-ruler";
import {
    getPageGuides,
    getPagePanel,
    refreshPagePanel,
    replacePagePanel
} from "./page-panel";
import {
    addPage,
    copyPage, getPagesContent,
    getSize,
    movePage,
    removePage,
    setPageSize
} from "./page";
import {afterZoomReposition, fitToPage, setZoom, setRevisionZoom, fitRevisionToPage} from "./zoom";
import {updateSizeGuide} from "./position";
import {ensureGroupDimensions} from "./dimension";
import {deselect, deselectAll, deselectMultiSelection, select, updatePageBars} from "./selection";
import {fixComponentLineHeight, setLineHeights} from "./line-height";
import {ensureGroupSize, group, regroup, ungroup} from "./group";
import {markAsModified} from "./mark-as-modified";
import Renderer from './renderer';
import {syncLayoutGuides} from "./layout-guides";
import { isElementOffPage } from './component';
import Interactable from "./interactable";
import { setIsMockData } from '../actions';
import { wrapToCurve } from './word-art';

function getDimensions() {
    return util.getActiveDimensions();
}

function ensureUniqueIds() {
    const $ids = $('.page').find('[id]');
    $ids.each(function () {
        $(this).attr('id', util.UUID.get());
    })
}

function fixLayeringIssue() {
    const $components = $('#pages').find('.move');
    $components.each(function () {
        const $this = $(this);
        if ($this.attr('data-component') && $this.css('z-index') === '1') {
            $this.css('z-index', '');
        }
    })
}

function updateTextColor($element, colorData) {
    const colorDataString = JSON.stringify(colorData);
    const oldColorDataString = $element.attr('data-color-text') ? $element.attr('data-color-text') : JSON.stringify({mode: 'solid', colors: [$element.css('color'), '#fff']});

    $element.attr('data-color-text', colorDataString);
    function update($element, colorDataString) {
        const colorData = JSON.parse(colorDataString);
        if (colorData.mode === 'solid') {
            $element.css('color', colorData.colors[0]);
            if (store.getState().textWrapped) {
                wrapToCurve($element);
            }
        }
    }

    const undo = () => { update($element, oldColorDataString) };
    const redo = () => { update($element, colorDataString) };

    redo();
    History.push(undo, redo, 'Update text color');
}

function updateTextFill($element, colorData, opacity=1) {
    const colorDataString = JSON.stringify(colorData);
    const oldColorDataString = $element.attr('data-color-fill') ? $element.attr('data-color-fill') : JSON.stringify({mode: 'solid', colors: [$element.css('color'), '#fff']});

    $element.attr({ 'data-color-fill': colorDataString, 'data-bg-opacity': opacity });
    function update($element, colorDataString) {
        const colorData = JSON.parse(colorDataString);
        let newbg = '';
        if (colorData.mode === 'solid') {
            newbg = colorData.colors[0];
        } else if (colorData.mode === 'gradient-horizontal') {
            newbg = `linear-gradient(180deg, ${colorData.colors[0]}, ${colorData.colors[1]})`;
        } else if (colorData.mode === 'gradient-vertical') {
            newbg = `linear-gradient(90deg, ${colorData.colors[0]}, ${colorData.colors[1]})`;
        } else if (colorData.mode === 'gradient-radial') {
            newbg = `radial-gradient(${colorData.colors[0]}, ${colorData.colors[1]})`;
        }
        $element.css('background', newbg);
    }

    const undo = () => { update($element, oldColorDataString) };
    const redo = () => { update($element, colorDataString) };

    redo();
    History.push(undo, redo, 'Update text color');
}

function updateTextLine($element, colorData) {
    const colorDataString = JSON.stringify(colorData);
    const oldColorDataString = $element.attr('data-color-line') ? $element.attr('data-color-line') : JSON.stringify({mode: 'solid', colors: [$element.css('color'), '#fff']});

    $element.attr('data-color-line', colorDataString);
    function update($element, colorDataString) {
        const colorData = JSON.parse(colorDataString);
        if (colorData.mode === 'solid') {
            $element.css('border-bottom-color', colorData.colors[0]);
        }
    }

    const undo = () => { update($element, oldColorDataString) };
    const redo = () => { update($element, colorDataString) };

    redo();
    History.push(undo, redo, 'Update text color');
}

function updateElementBorderColor($element, colorData) {
    const colorDataString = JSON.stringify(colorData);
    const oldColorDataString = $element.attr('data-color') ? $element.attr('data-color') : JSON.stringify({mode: 'solid', colors: [$element.css('color'), '#fff']});

    $element.attr('data-color', colorDataString);
    function update($element, colorDataString) {
        const colorData = JSON.parse(colorDataString);
        if (colorData.mode === 'solid') {
            let borderObject = util.getBorderElement($element);
            borderObject.css('border-color', colorData.colors[0]);
        }
    }

    const undo = () => { update($element, oldColorDataString) };
    const redo = () => { update($element, colorDataString) };

    redo();
    History.push(undo, redo, 'Update text color');
}

function updateElementMuted(element, newValue) {
    const oldValue = element.muted;

    function update(element, value) {
        element.muted = value;
        $(element).attr("muted", value);
        if (!value) {
            $(element).removeAttr("muted");
        }
    }

    const undo = () => { update(element, oldValue) };
    const redo = () => { update(element, newValue) };

    redo();
    History.push(undo, redo, 'Update muted');
}

function updateElementStyle($element, key, value, cfg = {}) {
    const $elements = Array.isArray($element) ? $element : [$element];
    const oldValues = key !== 'lineHeight' ? $elements.map($element => $element?.css(key)) : $elements.map($element => $element?.find('.txt').find('p:first').css(key));
    const values = $elements.map(_ => value);
    const oldScales = $elements.map($el => Interactable.of($el.hasClass('move') ? $el : $el.closest('.move')).getScale());

    function update($elements, key, values) {
        $elements.forEach(($element, idx) => {
            if (Text.isInlineStyle(key)) {
                Text.removeInlineStyling($element, key, values[idx]);
            }

            if (key === 'lineHeight') {
                $element?.find('.txt').find('p').css(key, values[idx]);
            } else {
                $element?.css(key, values[idx]);

                if (key === 'textTransform') {
                    $element?.find('.txt').css(key, values[idx]);
                } else if (key === 'borderRadius' && util.isFrame($element)) {
                    $element?.find('.img').css(key, values[idx]);
                }
            }

            const $text = $element?.hasClass('ql-container') ? $element?.parent() : $element;
            if (util.isText($text)) {
                const int = Interactable.of($text);
                if (key === 'fontSize') {
                    int.handleFontSizeChange();
                }

                if (util.isLineHeightAlteringStyle(key)) {
                    util.nextTick(() => { setLineHeights($element) });
                }
                if (util.isInGroup($text) && util.isGroupAlteringStyle(key)) {
                    util.nextTick(() => { ensureGroupDimensions($text) });
                }

                fixComponentLineHeight($text);
                Text.ensureTextSize($text);
                int.updateRect();
            }
        });
    }

    if (Text.isInlineStyle(key)) {
        $elements.forEach(($element, idx) => {
            Text.applyInlineStyle($element, key, values[idx], cfg, oldScales[idx]);
            if (util.isLineHeightAlteringStyle(key)) {
                util.nextTick(() => {
                    setLineHeights($element)
                });
            }
            const $text = $element?.hasClass('ql-container') ? $element?.parent() : $element;
            if (util.isText($text)) {
                if (util.isInGroup($text) && util.isGroupAlteringStyle(key)) {
                    util.nextTick(() => {
                        ensureGroupDimensions($text)
                    });
                }

                fixComponentLineHeight($text);
                Text.ensureTextSize($text);
                Interactable.of($text).updateRect();
            }
        });
        return;
    }

    const undo = () => { update($elements, key, oldValues) };
    const redo = () => { update($elements, key, values) };

    redo();
    History.push(undo, redo, 'Update element style');
}

function updateSvgStyleRule($element, allConfig, config, color) {
    function update($element, toEdit, color, allConfig) {
        toEdit.forEach(($elem) => $elem.css(config.rule, color));
        $element?.attr('data-configuration', allConfig);
    }

    const $editable = $element?.find('[data-custom-color]');
    const toEdit = [];
    $editable.each(function () {
        const $this = $(this);
        const attr = $this.attr('data-config');
        if (attr) {
            const cfgs = JSON.parse(attr);
            cfgs.forEach((cfg) => {
                if (cfg.id === config.id) {
                    toEdit.push($this);
                }
            });
        }
    });

    const oldColor = toEdit.length > 0 ? toEdit[0].css(config.rule) : color;
    const oldConfig = $element?.attr('data-configuration');

    const undo = () => { update($element, toEdit, oldColor, oldConfig) };
    const redo = () => { update($element, toEdit, color, JSON.stringify(allConfig)) };

    redo();
    History.push(undo, redo, 'Update element color');
}

function removeFrameImage($element) {
    const $elements = Array.isArray($element) ? $element : [$element];

    const $imgs = $elements.map($element => $element?.find('.img'));

    const oldImages = $imgs.map($img => $img.css('background-image'));
    const images = $elements.map(() => 'url("' + constants.urlPrefix + '/image/img-plc.png")');

    $elements.forEach($element => {
        $element.attr('data-pixabay-info', '');
        $element.attr('data-id', '');
        $element.attr('data-asset-id', '');
    });

    const apply = function(images) {
        $imgs.forEach(function($img, idx) {
            $img.css('background-image', images[idx]);
            $img.css('background-size', 'cover');
            $img.css('background-position', 'center center');
        });
    };

    const undo = () => apply(oldImages);
    const redo = () => apply(images);

    redo();
    History.push(undo, redo, 'Remove framed image');
}

function removeQrFromFrame($element) {
    const $elements = Array.isArray($element) ? $element : [$element];

    const $imgs = $elements.map($element => $element?.find('.img'));

    const oldImages = $imgs.map($img => $img.attr('src'));
    const images = $elements.map(() => constants.urlPrefix + '/image/qr-plc.jpg');

    const apply = function(images) {
        $imgs.forEach(($img, idx) => $img.attr('src', images[idx]));
    };

    const undo = () => apply(oldImages);
    const redo = () => apply(images);

    redo();
    History.push(undo, redo, 'Remove qr from QR frame');
}

function addQrToFrame($element, qrLink) {
    const $elements = Array.isArray($element) ? $element : [$element];

    const $imgs = $elements.map($element => $element?.find('.img'));

    const oldImages = $imgs.map($img => $img.attr('src'));
    const images = $elements.map(() => qrLink);

    const apply = function(images) {
        $imgs.forEach(($img, idx) => $img.attr('src', images[idx]));
    };

    const undo = () => apply(oldImages);
    const redo = () => apply(images);

    redo();
    History.push(undo, redo, 'Add QR to frame');
}

function copy($element) {
    const $elements = Array.isArray($element) ? $element : [$element];

    const $page = $elements[0].parents('.page');
    const pageBottom = $page.offset().top + $page.outerHeight(false);
    const pageRight = $page.offset().left + $page.outerWidth(false);

    const $clones = $elements.map($it => $it.clone());
    $clones.forEach(($clone, idx) => {
        const $element = $elements[idx];
        const cloneBottom = $element?.offset().top + $element?.outerHeight(false) + 50;
        const cloneRight = $element?.offset().left + $element?.outerWidth(false) + 50;

        const spaceTop = cloneBottom > pageBottom ? -50 : 50;
        const spaceLeft = cloneRight > pageRight ? -50 : 50;

        const spaceTopPercent = util.pixelToPercent(spaceTop, getDimensions().height);
        const spaceLeftPercent = util.pixelToPercent(spaceLeft, getDimensions().height);

        const isPercentTop = $element[0].style.top.indexOf('%') > -1;
        const isPercentLeft = $element[0].style.left.indexOf('%') > -1;
        const topPercent = isPercentTop ? $element[0].style.top : util.pixelToPercent($element[0].style.top.replace('px', ''), getDimensions().height);
        const leftPercent = isPercentLeft ? $element[0].style.left : util.pixelToPercent($element[0].style.left.replace('px', ''), getDimensions().height);

        const top = parseFloat(topPercent) + spaceTopPercent;
        const left = parseFloat(leftPercent) + spaceLeftPercent;

        const oldId = $clone.attr('id');
        const newId = util.UUID.get();

        $clone.css('top', `${top}%`);
        $clone.css('left', `${left}%`);
        $clone.attr('data-y', top);
        $clone.attr('data-x', left);
        $clone.attr('id', newId);

        const dataSource = $element.attr('data-source');
        const isToast = dataSource === 'toast';
        const isSquare = dataSource === 'square';
        const isPopmenu = dataSource === 'popmenu';
        const isTreez = dataSource === 'treez';
        const isItemLibrary = dataSource === 'itemlibrary';
        const isPos = isToast || isSquare || isTreez || isPopmenu || isItemLibrary;

        if (!isPos) {
            // if ($element.attr("data-id")) {
            //     $clone.attr("data-id", util.UUID.get());
            // }
            if ($element.attr('data-source')) {
                $clone.attr("data-source", 'mhm');
                $clone.find('*[data-source]').attr('data-source', 'mhm');
            }
        }

        $clone.find('[id]').each(function () { 
            if ($(this).attr('id') !== "svgWrap" && $(this).closest('#svgWrap').length <= 0) {
                $(this).attr('id', util.UUID.get());
            }
        });

        // for highlighted items
        if ($clone.attr('data-component') === 'menu-object') {
            $clone.find('.item[data-highlight-id]').each(function () {
                const $this = $(this);
                const oldId = $this.attr('data-highlight-id');
                const newId = util.UUID.get();
                $this.attr('data-highlight-id', newId);
                const oldConfig = $clone.find('.config').text();
                const newConfig = oldConfig.replaceAll(oldId, newId);
                $clone.find('.config').text(newConfig);
            });
        }

        if (MenuObject.isMenuObject($clone)) {
            MenuObject.refreshStyles($clone);
        } else if (util.isGroup($clone)) {
            $clone.find('.menu-object').each(function () {
                MenuObject.refreshStyles($(this));
            });
        }

        if ($clone.attr('data-base-animation') || $clone.attr('data-addon-animation')) {
            let cloneHTML = $clone.html();
            cloneHTML = cloneHTML.replaceAll(oldId, newId);
            $clone.html(cloneHTML);
        }
    });

    const undo = () => $clones.forEach($it => $it.remove());
    const redo = () => {
        $elements.forEach(($element, idx) => {
            const $clone = $clones[idx];

            $element?.parents('.content').append($clone);
            deselect($element);
            deselect($clone);

            Matrix.add({
                id: $clone.attr('id'),
                type: $clone.attr('data-component'),
                page: $page.attr('id'),
                left: $clone.attr('data-x'),
                top: $clone.attr('data-y'),
                width: $clone.width(),
                height: $clone.height()
            });
        });

        if ($clones.length === 1) {
            $clones[0].click();
        }
    };

    redo();
    History.push(undo, redo, 'Copy element');

    if ($clones.length === 1) {
        return $clones[0];
    } else {
        return $clones;
    }
}

function lock($element) {
    const $elements = Array.isArray($element) ? $element : [$element];

    function redo() {
        $elements.forEach($element => {
           if($element !== null) {
                $element?.addClass('locked');
                Interactable.of($element).lock();
           } else {
                deselectAll();
           }
        });
    }
    function undo() {
        $elements.forEach($element => {
            $element?.removeClass('locked');
            Interactable.of($element).unlock();
        });
    }

    redo();
    History.push(undo, redo, 'Lock');

    if ($elements.length === 1) {
        select($elements[0]);
    }
}

function unlock($element) {
    const $elements = Array.isArray($element) ? $element : [$element];
    function redo() {
        $elements.forEach($element => {
            $element?.removeClass('locked');
            Interactable.of($element).unlock();
        });
    }
    function undo() {
        $elements.forEach($element => {
            $element?.addClass('locked');
            Interactable.of($element).lock();
        });
    }

    redo();
    History.push(undo, redo, 'Unlock');

    if ($elements.length === 1) {
        select($elements[0]);
    }
}

function addHyperlink($element, url) {
    const $elements = Array.isArray($element) ? $element : [$element];

    function redo() {
        $elements.forEach($element => {
           if($element !== null) {
                $element?.addClass('hyperlink');
                $element?.attr('data-href', util.getValidUrl(url));
           } else {
                deselectAll();
           }
        });
    }

    function undo() {
        $elements.forEach($element => $element?.removeClass('hyperlink'));
    }

    redo();
    History.push(undo, redo, 'Add hyperlink');

    if ($elements.length === 1) {
        select($elements[0]);
    }
}

function removeHyperlink($element) {
    const $elements = Array.isArray($element) ? $element : [$element];

    function redo() {
        $elements.forEach($element => {
           if($element !== null) {
                $element?.removeClass('hyperlink');
                $element?.attr('data-href', '');
           } else {
                deselectAll();
           }
        });
    }
    function undo() {
        $elements.forEach($element => $element?.addClass('hyperlink'));
    }

    redo();
    History.push(undo, redo, 'Remove hyperlink');

    if ($elements.length === 1) {
        select($elements[0]);
    }
}

function isPageBackgroundChange(current, previous) {
    let isModified = false;
    if (current.indexOf('#') > -1 && previous.indexOf('rgb') > -1) {
        const prevHex = util.rgb2hex(previous);
        isModified = prevHex !== current;
    } else {
        isModified = previous !== current;
    }
    return isModified;
}

function updateShapeRadius($elem, key, value) {
    $elem.attr(key, value);
}

function setBackground($element, value) {
    let bg = JSON.parse(value);
    let newbg = '#fff';
    const mode = bg.mode;
    if (mode === 'solid') {
        newbg = bg.colors[0];
    } else if (mode === 'gradient-horizontal') {
        newbg = `linear-gradient(180deg, ${bg.colors[0]}, ${bg.colors[1]}`;
    } else if (mode === 'gradient-vertical') {
        newbg = `linear-gradient(90deg, ${bg.colors[0]}, ${bg.colors[1]}`;
    } else if (mode === 'gradient-radial') {
        newbg = `radial-gradient(${bg.colors[0]}, ${bg.colors[1]}`;
    }

    $element?.css('background', newbg);
}

function updatePageBackground($page, bg) {
    const colorDataString = JSON.stringify(bg);
    const oldColorDataString = $page.attr('data-color') ? $page.attr('data-color') :
                                JSON.stringify({mode: 'solid', colors: [$page.css('background-color'), '#fff']});

    markAsModified();

    $page.attr('data-color', colorDataString);
    const redo = () => setBackground($page, colorDataString);
    const undo = () => setBackground($page, oldColorDataString);
    redo();
    History.push(undo, redo, 'Change page background');
}


function updateBackground(bg) {
    markAsModified();
    const $page = $('.page');

    let previous = $page.css('backgroundImage');
    if (previous === 'none') previous = $page.css('backgroundColor');

    const redo = () => setBackground($page, bg);
    const undo = () => setBackground($page, previous);

    redo();
    History.push(undo, redo, 'Change background');
}

function getPageBackgroundCss($page) {
    return $page?.css('background');
}

function getElementInRotation(event) {
    const $target = $(event.target);
    let $element = $target.parents('[data-component]');

    if ($target.closest('.page-bar').length > 0) {
        const id = $target.closest('.page-bar').attr('id');
        $element = $target.closest('.page').find(`.content div#${id}`);
    }
    return $element[0];
}

function onComponentRotateStart(event) {
    const element = getElementInRotation(event);
    const rect = element.getBoundingClientRect();

    element.dataset.centerX = rect.left + rect.width / 2;
    element.dataset.centerY = rect.top + rect.height / 2;

    const startAngle = element.dataset.angle || 0;
    $(event.target).attr('data-original-angle', startAngle);

    element.dataset.angle = getDragAngle(event);
}

function onComponentRotate(event) {
    const $element = $(getElementInRotation(event));
    const angle = getDragAngle(event);
    transformElementRotation($element, angle);
    updateSizeGuide($element, util.radToDegree(angle));
    updatePageBars($element);
}

function onComponentRotateEnd(event) {
    const $element = $(getElementInRotation(event));
    const angle = getDragAngle(event);

    $element?.find('.size-guide').remove();

    const doAction = (angle) => {
        $element[0].dataset.angle = angle;
        $element?.css('transform', `rotate(${angle}rad)`);
        $element?.css('-webkit-transform', `rotate(${angle}rad)`);

        const transform = JSON.parse($element.attr('data-transform') || '{}');
        const verticalFlip = transform.verticalFlip || false;
        const horizontalFlip = transform.horizontalFlip || false;
        const scale = transform.scale || 100;
        let rotationDeg = transform.rotationDeg || 0;
        rotationDeg = parseFloat(angle);
        $element?.attr('data-transform', JSON.stringify({
            verticalFlip, horizontalFlip, rotationDeg, scale
        }));

        util.nextTick(() => {
            Renderer.deselectAll();
            store.dispatch(actions.deselect());
            Renderer.select($element);
            store.dispatch(actions.select($element));
        })
    };

    const oldAngle = $(event.target).attr('data-original-angle');

    const redo = () => doAction(angle);
    const undo = () => doAction(oldAngle);

    redo();
    History.push(undo, redo, 'Rotate');
}

function getDragAngle(event) {
    const element = getElementInRotation(event);

    const startAngle = parseFloat(element.dataset.angle) || 0;
    const center = {
        x: parseFloat(element.dataset.centerX) || 0,
        y: parseFloat(element.dataset.centerY) || 0,
    };

    let angle = Math.atan2(center.y - event.clientY, center.x - event.clientX);
    angle -= startAngle;

    const { isShiftPressed } = store.getState();
    if (isShiftPressed) {
        let deg = util.toDegrees(angle);
        deg = parseInt(`${deg / 45}`, 10) * 45;
        angle = util.toRadians(deg);
    }

    return angle;
}

function setPreserveRatio($element, val) {
    $element?.attr('data-preserve-ratio', val)
}

function transformElementRotation($element, rotationDeg) {
    const transform = JSON.parse($element?.attr('data-transform') || '{}');
    const verticalFlip = transform.verticalFlip || false;
    const horizontalFlip = transform.horizontalFlip || false;
    const scale = transform.scale || 100;

    transformElement($element, verticalFlip, horizontalFlip, rotationDeg, scale, false);
}

function transformElement($element, verticalFlip, horizontalFlip, rotationDeg, scale, addInHistory = true) {
    const oldTransform = JSON.parse($element?.attr('data-transform') || '{}');
    const oldVerticalFlip = oldTransform.verticalFlip || false;
    const oldHorizontalFlip = oldTransform.horizontalFlip || false;
    const oldRotationDeg = oldTransform.rotationDeg || 0;

    function doAction($element, verticalFlip, horizontalFlip, rotationDeg, scale) {
        let scaleTransform = [1, 1];
        if (verticalFlip && horizontalFlip) scaleTransform = [-1, -1];
        else if (verticalFlip) scaleTransform = [1, -1];
        else if (horizontalFlip) scaleTransform = [-1, 1];

        scaleTransform[0] *= (scale / 100);
        scaleTransform[1] *= (scale / 100);

        let $content = null;
        if (util.isIllustration($element)) {
            $content = $element?.find('.svg-content');
        } else {
            $content = $element?.find('.img');
            if ($content.length === 0) {
                $content = $element?.find('img');

                if ($content.length === 0) {
                    $content = $element?.find('video');
                }
            }
        }

        if ($content) {
            $content.css('transform', `scale(${scaleTransform.join(',')})`);
            $content.css('-webkit-transform', `scale(${scaleTransform.join(',')})`);

            Interactable.of($element).setRotation(rotationDeg);
            Interactable.of($element).refreshPosition(true);


            $element?.attr('data-transform', JSON.stringify({
                verticalFlip, horizontalFlip, rotationDeg, scale
            }));
        }
    }

    const redo = () => doAction($element, verticalFlip, horizontalFlip, rotationDeg, scale);
    const undo = () => doAction($element, oldVerticalFlip, oldHorizontalFlip, oldRotationDeg, scale);

    redo();
    if (addInHistory) {
        History.push(undo, redo, 'Flip');
    }
}

function addPageHelpers($page) {
    $page.append(getPageGuides());

    if (!store.getState().isMobileVersion) {
        $page.append(getPagePanel());
    }

    const $panels = $page.find('.panel');
    $panels.each(function () {
        const $this = $(this);
        $this.find('.tippy').each(function () { tippy.one(this) });
    })
}

function handleQRFunnel(isMobile) {
    let qrCodes = $('.pages').find('[data-component="qr-code"]');
    if (qrCodes.length === 1 && util.isQRFrameEmpty(qrCodes)) {
        store.dispatch(actions.setIsAddQRMode(true));
        if (isMobile) {
            store.dispatch(actions.setIsMobileAside(true));
        }
        store.dispatch(actions.setView('qr-codes'));
    } else if (qrCodes.length > 1) {
        store.dispatch(actions.setIsAddQRMode(true));
        let allEmpty = true;
        qrCodes.each(function() {
            if (!util.isQRFrameEmpty($(this))) {
                allEmpty = false;
            }
        });
        if (allEmpty) {
            if (isMobile) {
                store.dispatch(actions.setIsMobileAside(true));
            }
            store.dispatch(actions.setView('qr-codes'));
        }
    }
    store.dispatch(actions.setIsQRDesignMode(false));
}

export function renderDesign(design, config) {
    config = config || {};

    Interactable.destroyAll();

    populateDesign(design, config);
    loadSafeZoneSettings();
    loadCanvasStyles();

    syncLayoutGuides();
    convertQrObjects();
    convertMenuObjects();
    addBlankAltText();
    if (window.data.member.uploadedImages) {
        syncUploadedImagesAltTextOnCanvas(window.data.member.uploadedImages);
        window.data.member.uploadedImages = '';
    }
    if (window.data.member.uploadedLogo) {
        syncUploadedImagesAltTextOnCanvas(window.data.member.uploadedLogos);
        window.data.member.uploadedLogos = '';
    }
    if (window.data.member.uploadedIcons) {
        syncUploadedIconsAltTextOnCanvas(window.data.member.uploadedIcons);
        window.data.member.uploadedIcons = '';
    }

    if (util.isSafari()) {
        setZoom(100);
    } else {
        setTimeout(() => {
            fitToPage();
        });
    }

    util.onFontsLoaded(() => {
        setLineHeights();
        if (util.isSafari()) {
            setLineHeights();
            util.nextTick(fitToPage);
        }
        fixDots();

        $('div[data-component="menu-object"]').each(function() {
            Interactable.of($(this)).afterRestore();
            MenuObject.fixNameNotesPadding($(this));
        });
    });

    if (store.getState().isQRDesignMode && !config.isMobile) {
        handleQRFunnel(false);
    }

    if (config.isMobile) {
        setTimeout(() => {
            $('div[data-component="menu-object"]').each(function() {
                const $this = $(this);
                let layout = $this.attr('data-layout');
                MenuObject.updateLayout($this, layout, false);
            })

            if (store.getState().isQRDesignMode) {
                handleQRFunnel(true);
            }
        }, 1500);
    }
    Interactable.refreshPageNumber();
    Interactable.initElements();

    let mockCount = 0;
    let itemCount = 0;
    $(".mo-content").find(".item").each(function() {
        const $item = $(this);
        itemCount += 1;
        if ($item.attr("data-mock") === "true") mockCount += 1;
    });

    if (mockCount === itemCount) {
        store.dispatch(actions.setIsMockData(true));
    }
}

function fixDots() {
    $('div[data-component="menu-object"]').each(function() {
        MenuObject.fixDots($(this));
    });
}

function populateDesign(design, config) {
    config = config || {};
    const size = design.size ? util.getSize(design.size) : util.sizes[1];
    design.size = size.key;

    if (design.isCustomSize) {
        size.unit = design.unit;
        size.width = design.width;
        size.height = design.height;
        if (size.unit === 'in') {
            size.width = design.width + 0.25;
            size.height = design.height + 0.25;
            size.bleed = 0.25;
        }
    }

    setPageSize(size);

    if (design.html) {
        $('#pages').html(design.html);
        $('.page').each(function () {
            addPageHelpers($(this));
        });
    } else {
        addPage();
        if (util.isTakeout(size.key) || util.isFoldedMenu(size.key)) {
            addPage();
        }
    }
    store.dispatch(actions.setDesign(design));

    if (config.isFromTemplate === true) {
        ensureUniqueIds();
        util.nextTick(() => {
            $('.page').find('.menu-object').each(function () {
                MenuObject.fixLayouts($(this));
            });
        });
    }

    util.nextTick(() => {
        $('.page').find('.menu-object').each(function () {
            const $this = $(this);
            MenuObject.ensureHasWrapper($this);
        });
    });

    fixAllQRRatio();

    refreshPagePanel();
    setTextBlocks();
    setEditables({ clear: true });

    Matrix.clear();
    Matrix.init();

    Cleaner.removeElementsOffPage();

    util.nextTick(deselectAll);
    $('.bars').remove();
}

export function fixAllQRRatio() {
    util.nextTick(() => {
        $('.page').find('*[data-component="qr-code"]').each(function() {
            const $comp = $(this);
            fixQRRatio($comp);
        });
    });
}

export function fixQRRatio($comp) {
    if (!$comp) return;
    const $img = $comp.find('img');
    $comp.css('height', $img.css('height'));
}

function previewRevision(html) {
    const $pages = $('#pages');
    const $preview = $('#preview-pages');
    $preview.show();
    $preview.html(html);
    $pages.hide();

    if (store.getState().isMobileVersion) {
        util.nextTick(fitRevisionToPage);
    } else {
        setRevisionZoom(70);
    }

    const dims = getDimensions();
    const revisionPageSize = $preview.find('.page:first').attr('data-size');

    if (dims.key !== revisionPageSize) {
        setPageSize(util.getSize(revisionPageSize));
    }

    afterZoomReposition();
}

function revertRevisionPreview() {
    const $preview = $('#preview-pages');
    $preview.html('');
    $preview.hide();

    const $pages = $('#pages');

    const revisionPageSize = store.getState().designSize;
    const size = util.getSize(revisionPageSize);
    setPageSize(size);

    $pages.show();

    revisionCleanup(size);
}

function useRevision() {
    populateHtml($('#preview-pages').html(), { keepIds: true });

    const sizeKey = $('#pages').children(':first').attr('data-size');
    const size = util.getSize(sizeKey);
    store.dispatch(actions.setDesignSize(size));
}

function revisionCleanup(size) {
    setTextBlocks();
    setEditables({ clear: true });

    Matrix.clear();
    Matrix.init();
    History.clear();

    util.nextTick(() => {
        setPageSize(size);
        updateRuler();
        afterZoomReposition()

        deselectAll();
        MenuObject.resetLineHeightsStandalone();
    })
}

function populateHtml(html, cfg = {}) {
    const $preview = $('#preview-pages');
    $preview.html('');
    $preview.hide();

    const $pages = $('#pages');
    $pages.html(html);
    $pages.show();

    $('.page').each(function () {
        addPageHelpers($(this));
    });

    if (!cfg.keepIds) {
        ensureUniqueIds();
    }
    replacePagePanel();
}

function loadSafeZoneSettings() {
    const $pages = $('#pages');
    const $children = $pages.children();
    $children.each(function (index) {
        const isLastElement = index === $children.length - 1;
        const dataSafeZone = $(this).attr('data-safe-zone');
        const isSafeZoneToggled = dataSafeZone === undefined ? true : (dataSafeZone === 'true');
        setSafeZone(isSafeZoneToggled, isLastElement);
    });
}

function updateSafeZoneOnCanvas(isSafeZoneToggled, doUpdate = true) {
    const $pages = $('#pages');
    $pages.children().each(function () {
        $(this).attr('data-safe-zone', isSafeZoneToggled.toString());
    });

    if (doUpdate) {
        const html = Renderer.getPagesContent();

        const callback = () => {
            store.dispatch(actions.setIsSaved(true));
            store.dispatch(actions.setIsSaving(false));
        }

        if (html) {
            designService.updateDesignHtml({
                id: store.getState().designId,
                html,
                lastSavedTag: store.getState().lastSavedTag,
                hasChanges: true,
                hasVideo: store.getState().hasVideo
            }).then(() => {
                callback();
            });
        } else {
            callback();
        }
    }
}

function loadCanvasStyles() {
    loadSafeZoneSettings();
    const sizeKey = $('#pages').children(':first').attr('data-size');
    const size = util.getSize(sizeKey);
    store.dispatch(actions.setDesignSize(size));

    if(sizeKey === 'custom' &&  store.getState().designUnit === 'in') {
        if (!$('.bleed-shadow-top').children().length) {
            $('.bleed-shadow-top').append('<div class="safe-zone-label">SAFE ZONE</div>');
        }
    } else if(sizeKey !== 'custom' && sizeKey !== 'fb-post' && sizeKey !== 'fb-story' && sizeKey !== 'insta-story' && sizeKey !== 'insta-post' && sizeKey !== 'logo' && sizeKey !== 'digital-menu-board' && sizeKey !== 'digital-menu-board-portrait') {
        if (!$('.bleed-shadow-top').children().length) {
            $('.bleed-shadow-top').append('<div class="safe-zone-label">SAFE ZONE</div>');
        }
    }

    const styles = '.page .content .comp, .page .content .image, .page .content .qr, .page .content .group, .page .content .frame { z-index: 1; }'
        + '.page .txt { line-height: 1; }'
        + '* { box-sizing: border-box; }'
        + '[data-component=text] { text-decoration-skip-ink: none; line-height: 1; color: #777; }'
        + '[data-component=text] .txt { text-decoration: inherit; }'
        + '.image, .svg-content { display: flex; }'
        + '.svg-content { width: 100%; height: 100%; }'
        + '#canvas .page .txt { line-height: 1; width: 100%; white-space: normal; }';

    $('#canvas-styles').remove();
    $('#canvas').append(`<style id="canvas-styles">${styles}</style>`);
}

function updateElementLineStyle($element, style) {
    const $path = $element ? getSvgPath($element) : null;

    function update(strokeDasharray, strokeLinecap) {
        $path.attr('stroke-dasharray', strokeDasharray);
        $path.attr('stroke-linecap', strokeLinecap);
    }

    const oldDasharray = $path.attr('stroke-dasharray');
    const oldLinecap = $path.attr('stroke-linecap');

    const redo = () => update(style.strokeDasharray, style.strokeLinecap);
    const undo = () => update(oldDasharray, oldLinecap);

    redo();
    History.push(undo, redo, 'Update style')
}

function updateElementLineHeight($element, height) {
    const $path = $element ? getSvgPath($element) : null;
    const oldHeight = $path.attr('stroke-width');

    $path.attr('data-original-stroke-width', height);

    const redo = () => $path.attr('stroke-width', util.getStrokeWidth(height, getDimensions().width));
    const undo = () => $path.attr('stroke-width', oldHeight);

    redo();
    History.push(undo, redo, 'Update line height');
}

function updateElementFillColor($element, colorData, opacity = 1) {
    if ($element && $element.attr('data-color') === JSON.stringify(colorData) && $element.attr('data-opacity') === opacity) return;

    const $path = $element ? getSvgPath($element) : null;
    const colorDataString = JSON.stringify(colorData);
    const oldColorDataString = $element.attr('data-color') ? $element.attr('data-color') :
                                $path.attr('fill') === 'none' ? JSON.stringify({mode: 'solid', colors: ['#ffffff00', '#fff']}) :
                                JSON.stringify({mode: 'solid', colors: [$path.attr('fill'), '#fff']});

    $element?.attr({'data-color': JSON.stringify(colorData), 'data-opacity': opacity});

    function setFillColor(colorDataString) {
        let colorData = JSON.parse(colorDataString);
        const svgContent = $element.find('.svg-content');
        const defs = svgContent.find('defs');
        if (colorData.mode === 'no-fill') {
            $path.attr('fill', 'none');
            if (defs.length > 0) {
                defs.remove();
            }
        } else if (colorData.mode === 'solid') {
            $path.attr('fill', colorData.colors[0]);
            if (defs.length > 0) {
                defs.remove();
            }
        } else if (colorData.mode === 'gradient-horizontal') {
            if (defs.length > 0) {
                let id = defs.children().first().attr('id');
                let newDefsHtml = `<linearGradient id="${id}" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" style="stop-color:${colorData.colors[0]};stop-opacity:1"></stop>
                    <stop offset="100%" style="stop-color:${colorData.colors[1]};stop-opacity:1"></stop>
                </linearGradient>`;
                defs.html(newDefsHtml);
                $path.attr('fill', `url(#${id})`);
            } else {
                let newId = util.UUID.get();
                let newDefs = `<defs>
                    <linearGradient id="${newId}" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" style="stop-color:${colorData.colors[0]};stop-opacity:1"></stop>
                        <stop offset="100%" style="stop-color:${colorData.colors[1]};stop-opacity:1"></stop>
                    </linearGradient>
                </defs>`;
                $path.before(newDefs);
                $path.attr('fill', `url(#${newId})`);

                // force redraw of svg
                const html = svgContent.html();
                svgContent.html('');
                svgContent.html(html);
            }
        } else if (colorData.mode === 'gradient-vertical') {
            if (defs.length > 0) {
                let id = defs.children().first().attr('id');
                let newDefsHtml = `<linearGradient id="${id}" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style="stop-color:${colorData.colors[0]};stop-opacity:1"></stop>
                    <stop offset="100%" style="stop-color:${colorData.colors[1]};stop-opacity:1"></stop>
                </linearGradient>`;
                defs.html(newDefsHtml);
                $path.attr('fill', `url(#${id})`);
            } else {
                let newId = util.UUID.get();
                let newDefs = `<defs>
                    <linearGradient id="${newId}" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style="stop-color:${colorData.colors[0]};stop-opacity:1"></stop>
                        <stop offset="100%" style="stop-color:${colorData.colors[1]};stop-opacity:1"></stop>
                    </linearGradient>
                </defs>`;
                $path.before(newDefs);
                $path.attr('fill', `url(#${newId})`);

                // force redraw of svg
                const html = svgContent.html();
                svgContent.html('');
                svgContent.html(html);
            }
        } else if (colorData.mode === 'gradient-radial') {
            if (defs.length > 0) {
                let id = defs.children().first().attr('id');
                let newDefsHtml = `<radialGradient id="${id}">
                    <stop offset="0%" style="stop-color:${colorData.colors[0]};stop-opacity:1"></stop>
                    <stop offset="100%" style="stop-color:${colorData.colors[1]};stop-opacity:1"></stop>
                </radialGradient>`;
                defs.html(newDefsHtml);
                $path.attr('fill', `url(#${id})`);
            } else {
                let newId = util.UUID.get();
                let newDefs = `<defs>
                    <radialGradient id="${newId}">
                        <stop offset="0%" style="stop-color:${colorData.colors[0]};stop-opacity:1"></stop>
                        <stop offset="100%" style="stop-color:${colorData.colors[1]};stop-opacity:1"></stop>
                    </radialGradient>
                </defs>`;
                $path.before(newDefs);
                $path.attr('fill', `url(#${newId})`);

                // force redraw of svg
                const html = svgContent.html();
                svgContent.html('');
                svgContent.html(html);
            }
        }
    }

    const redo = () => setFillColor(colorDataString);
    const undo = () => setFillColor(oldColorDataString);

    redo();
    History.push(undo, redo, 'Update fill color');
}

function updateElementLineColor($element, hex) {
    const $path = $element ? getSvgPath($element) : null;
    const oldHex = $path.attr('stroke');
    if (oldHex === hex) return;

    const redo = () => $path.attr('stroke', hex);
    const undo = () => $path.attr('stroke', oldHex);

    redo();
    History.push(undo, redo, 'Update line color');
}

function updateElementWidth($element, cfg, skipHistory) {
    const $elements = Array.isArray($element) ? $element : [$element];

    const oldWidth = $elements.map($element => $element?.attr('data-original-width') || $element?.width());
    const width = $elements.map(() => cfg.in ? util.inchToPixel(cfg.in) : cfg.px * getDimensions().onePixelRatio);

    function resize(width) {
        $elements.forEach(($element, idx) => {
            $element?.attr('data-original-width', width[idx]);

            if (cfg.in) {
                $element?.attr('data-inch-width', util.pixelToInch(width[idx]));
            } else if (cfg.px) {
                $element?.attr('data-px-width', width[idx] / util.getActiveDimensions().onePixelRatio);
            }

            Interactable.of($element).resizeWidth(width[idx], false);

            if (isElementOffPage($element)) {
                Cleaner.removeElement($element);
                store.dispatch(actions.deselect());
            }
        });
    }

    skipHistory = true;
    const redo = () => resize(width);
    if (!skipHistory) {
        const undo = () => resize(oldWidth);
        History.push(undo, redo, 'Update element width');
    }
    redo();
}

function updateElementHeight($element, cfg) {
    const $elements = Array.isArray($element) ? $element : [$element];

    const oldHeight = $elements.map($element => $element?.attr('data-original-height') || $element?.height());
    const height = $elements.map(() =>cfg.in ? util.inchToPixel(cfg.in) : cfg.px * getDimensions().onePixelRatio);

    function resize(height) {
        $elements.forEach(($element, idx) => {
            //$element?.css('height', `${util.pixelToPercent(height[idx], getDimensions().height)}%`);
            $element?.attr('data-original-height', height[idx]);

            if (cfg.in) {
                $element?.attr('data-inch-height', util.pixelToInch(height[idx]));
            } else if (cfg.px) {
                $element?.attr('data-px-height', height[idx] / util.getActiveDimensions().onePixelRatio);
            }

            Interactable.of($element).resizeHeight(height[idx], false);

            if (isElementOffPage($element)) {
                // $element?.css('top', '0%');
                Cleaner.removeElement($element);
                store.dispatch(actions.deselect());
            }
        });
    }

    const redo = () => resize(height);
    const skipHistory = true;
    if (!skipHistory) {
        const undo = () => resize(oldHeight);
        History.push(undo, redo, 'Update element height');
    }
    redo();
}

function resizeElement($element, width, height, cfg) {
    $element?.css('width', `${util.pixelToPercent(width, getDimensions().width)}%`);
    $element?.css('height', `${util.pixelToPercent(height, getDimensions().height)}%`);

    $element?.attr('data-original-width', width);
    $element?.attr('data-original-height', height);

    if (cfg.in) {
        $element?.attr('data-inch-width', util.pixelToInch(width));
        $element?.attr('data-inch-height', util.pixelToInch(height));
    } else if (cfg.px) {
        $element?.attr('data-px-width', width / util.getActiveDimensions().onePixelRatio);
        $element?.attr('data-px-height', height / util.getActiveDimensions().onePixelRatio);
    }
}

function updateWidthAndHeightByWidth($element, cfg) {
    if($element !== null) {
        const $elements = Array.isArray($element) ? $element : [$element];

        const oldWidth = $elements.map($element => $element?.attr('data-original-width') || $element?.width());
        const oldHeight = $elements.map($element => $element?.attr('data-original-height') || $element?.height());

        const width = $elements.map(() => cfg.in ? util.inchToPixel(cfg.in) : cfg.px * getDimensions().onePixelRatio);
        const height = $elements.map(($element, idx) => {
            const ratio = parseFloat($element?.attr('data-custom-ratio') || $element?.attr('data-ratio'));
            return 1 / ratio * width[idx];
        });

        function redo(undo) {
            $elements.forEach(($element, idx) => {
                resizeElement($element, width[idx], height[idx], cfg)

                if (isElementOffPage($element)) {
                    // $element?.css('left', '0%');
                    Cleaner.removeElement($element);
                    store.dispatch(actions.deselect());
                }
            });
        }

        function undo() {
            $elements.forEach(($element, idx) => {
                resizeElement($element, oldWidth[idx], oldHeight[idx], cfg)
            });
        }

        redo();
        History.push(undo, redo, 'Update element width and width');

        return cfg.in ? util.pixelToInch(height) : Math.ceil(height * (1 / getDimensions().onePixelRatio) * 100) / 100;
    } else {
        deselectAll();
    }
}

function updateWidthAndHeightByHeight($element, cfg) {
    const $elements = Array.isArray($element) ? $element : [$element];

    const oldWidth =  $elements.map($element => $element?.attr('data-original-width') || $element?.width());
    const oldHeight =  $elements.map($element => $element?.attr('data-original-height') || $element?.height());

    const height = $elements.map($element => {
        if (cfg.in) {
            $element?.attr('data-inch-height', cfg.in);
        }
        return cfg.in ? util.inchToPixel(cfg.in) : cfg.px * getDimensions().onePixelRatio;
    });

    const width = $elements.map(($element, idx) => {
        const ratio = parseFloat($element?.attr('data-custom-ratio') || $element?.attr('data-ratio'));
        return ratio * height[idx];
    });

    function redo() {
        $elements.forEach(($element, idx) => {
            resizeElement($element, width[idx], height[idx], cfg)
        });

        if (isElementOffPage($element)) {
            // $element?.css('top', '0%');
            Cleaner.removeElement($element);
            store.dispatch(actions.deselect());
        }
    }

    function undo() {
        $elements.forEach(($element, idx) => {
            resizeElement($element, oldWidth[idx], oldHeight[idx], cfg)
        });
    }

    redo();
    History.push(undo, redo, 'Update element width and height');

    return cfg.in ? util.pixelToInch(width) : Math.ceil(width * (1 / getDimensions().onePixelRatio) * 100) / 100;
}

function distributeHorizontally(elements) {
    const zoom = store.getState().zoom / 100;

    const rry = [];

    let actualWidth = 0;
    let mostLeft = Number.MAX_SAFE_INTEGER;
    let mostRight = -1;

    elements.forEach(($it) => {
        const int = Interactable.of($it);
        const rect = int.getRect();
        let width = rect.width * zoom;
        let left = rect.left;

        actualWidth += width;
        rry.push({ $it, width, left });

        if (left < mostLeft) mostLeft = left;
        if (left + width > mostRight) mostRight = left + width;
    });

    rry.sort((a, b) => a.left - b.left);
    const totalWidth = mostRight - mostLeft;
    const spacing = (totalWidth - actualWidth) / (elements.length - 1);

    for (let idx = 1; idx < rry.length; idx++) {
        const prev = rry[idx - 1];
        const it = rry[idx];
        const prevLeft = it.left;
        it.left = (prev.left + prev.width + spacing);
        const diff = (prevLeft - it.left);

        const int = Interactable.of(it.$it);
        int.setTranslateX(int.getTranslateX() - diff);
        int.refreshPosition();
    }
}

function distributeVertically(elements) {
    const zoom = store.getState().zoom / 100;

    const rry = [];

    let actualHeight = 0;
    let mostTop = Number.MAX_SAFE_INTEGER;
    let mostBottom = -1;

    elements.forEach(($it) => {
        const int = Interactable.of($it);
        const rect = int.getRect();
        let height = rect.height * zoom;
        let top = rect.top;

        actualHeight += height;
        rry.push({ $it, height, top });

        if (top < mostTop) mostTop = top;
        if (top + height > mostBottom) mostBottom = top + height;
    });

    rry.sort((a, b) => a.top - b.top);

    const totalHeight = mostBottom - mostTop;
    const spacing = (totalHeight - actualHeight) / (elements.length - 1);

    for (let idx = 1; idx < rry.length; idx++) {
        const prev = rry[idx - 1];
        const it = rry[idx];
        const prevTop = it.top;
        it.top = prev.top + prev.height + spacing;
        const diff = (prevTop - it.top);

        const int = Interactable.of(it.$it);
        int.setTranslateY(int.getTranslateY() - diff);
        int.refreshPosition();
    }
}

function distribute(horizontally, vertically) {
    const elements = [];
    store.getState().$elements.forEach(($elem) => {
        if ($elem.hasClass('locked')) {
        return true;
        }
        elements.push(util.isInGroup($elem) ? $elem.parents('.group') : $elem);
    });

    function doAction() {
        if (horizontally) distributeHorizontally(elements);
        if (vertically) distributeVertically(elements);
        store.getState().$elements.forEach(($elem) => {
            updatePageBars($elem);
        });
    }

    function undoAction() {}

    const redo = () => doAction();
    const undo = () => undoAction();

    redo();
    History.push(undo, redo, 'Align')
}

function getImagePath($element) {
    let $img = $element?.find('img');
    let img = '';

    if ($img.length > 0) {
        img = $img.attr('src').split('amazonaws.com/')[1];
    } else {
        $img = $element?.find('.img');
        img = $img.css('background-image').split('amazonaws.com/')[1];
        img = img.substring(0, img.length - 2);
    }

    if (img.indexOf('?v' > -1)) {
        img = img.split('?v')[0];
    }
    return img;
}

function refreshImage($element, path) {
    path = `http://mhm-timber.s3-website-us-east-1.amazonaws.com/${path}`;

    let $img = $element?.find('img');
    if ($img.length > 0) {
        $img.attr('src', `${path}?v=${new Date().getTime()}`);
    } else {
        $img = $element?.find('.img');
        $img.css('background-image', `url("${path}?v=${new Date().getTime()}")`);
    }
}

function setEditables(cfg = {}) {
    if (cfg.clear) {
        Text.clearQuills();
    }
    const $components = $('#pages').find('[data-component="text"]');
    $components.each(function () {
        Text.initQuill($(this));
    });
}

function setTextBlocks() {
    const $components = $('#pages').find('[data-component="text"]');
    $components.each(function () {
        Text.ensureTextBlocks($(this));
    });
}

function setSafeZone(isSafeZoneToggled, doUpdate = true) {
    store.dispatch(actions.showSafetyZone(isSafeZoneToggled));
    localStorage.setItem('safeZone', isSafeZoneToggled);
    updateSafeZoneOnCanvas(isSafeZoneToggled, doUpdate);

    isSafeZoneToggled === true && !store.getState().isMobileVersion?
        $('.bleed-shadow-top, .bleed-shadow-left, .bleed-shadow-right, .bleed-shadow-btm, .bleed-shadow-fold-one, .bleed-shadow-fold-two, .bleed-shadow-fold-three ').show():
        $('.bleed-shadow-top, .bleed-shadow-left, .bleed-shadow-right, .bleed-shadow-btm, .bleed-shadow-fold-one, .bleed-shadow-fold-two, .bleed-shadow-fold-three ').hide();
}


function getSafeZoneFromDesign(doUpdate = true) {
    const isSafeZoneToggled = localStorage.getItem('safeZone') ? localStorage.getItem('safeZone') === 'true' : true;
    setSafeZone(isSafeZoneToggled, doUpdate);
}

function addAlphaToColorData(colorData, opacity) {
    let tcColorPrimary = tinycolor(colorData.colors[0]);
    let tcColorSecondary = tinycolor(colorData.colors[1]);
    tcColorPrimary.setAlpha(opacity);
    tcColorSecondary.setAlpha(opacity);
    colorData.colors = [tcColorPrimary.toRgbString(), tcColorSecondary.toRgbString()];
    return colorData;
}

export default {
    setPageSize,
    setZoom,
    addPage,
    copyPage,
    movePage,
    removePage,
    getPagesContent,
    fixLayeringIssue,
    distribute,

    populateDesign,
    previewRevision,
    revertRevisionPreview,
    useRevision,

    getSize,
    getDimensions,

    updateTextColor,
    updateTextFill,
    updateTextLine,
    updateElementBorderColor,
    updateElementStyle,
    updateSvgStyleRule,
    updatePageBackground,
    getPageBackgroundCss,
    updateBackground,
    updateShapeRadius,
    updateElementMuted,

    transformElement,

    select,
    deselect,
    deselectMultiSelection,
    deselectAll,

    group,
    ungroup,
    regroup,
    ensureGroupDimensions,

    remove: Cleaner.removeElement,
    removeElements: Cleaner.removeElements,
    removeFrameImage,
    removeQrFromFrame,
    addQrToFrame,
    copy,

    lock,
    unlock,

    addHyperlink,
    removeHyperlink,

    onComponentRotateStart,
    onComponentRotate,
    onComponentRotateEnd,

    updateElementLineStyle,
    updateElementLineHeight,

    updateElementFillColor,
    updateElementLineColor,

    updateElementWidth,
    updateElementHeight,

    updateWidthAndHeightByWidth,
    updateWidthAndHeightByHeight,

    loadCanvasStyles,
    loadSafeZoneSettings,
    updateSafeZoneOnCanvas,

    toggleRuler,
    getImagePath,

    setSafeZone,
    getSafeZoneFromDesign,
    setPreserveRatio,
    refreshImage,
    getActiveEditable: () => Cached.getEditable(),

    setLineHeights,
    ensureGroupSize,

    addAlphaToColorData
}
